// @core/api/endpoints/chat/archive_conversation.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ArchiveConversationRequest,
} from '../../../types/chat';

const BASE_PATH = '/chat';

/**
 * Archive conversation
 * Archives or unarchives a conversation for the current user. Archived conversations are hidden from the main list but can be restored.
 */
export async function ArchiveConversation(
  conversation_id: string,
  data: ArchiveConversationRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/conversations/:conversation_id/archive`;
  requestPath = requestPath.replace(':conversation_id', encodeURIComponent(conversation_id));
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
